import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, retry, tap } from "rxjs/operators";
import { loadChatHubProviders, setChatHubProvidersAction } from "../actions/flow.action";
import { ChatHubService } from "../../services/chathub/chat-hub.service";
import {chatHubErrorObject, NodeObject} from "../../../shared/utils/nodeTypes";
import { of } from "rxjs";

@Injectable()
export class chatHubProviderEffects {
    chatHubProviders$ = createEffect(() =>
        this.actions$.pipe(
            ofType(loadChatHubProviders),
            mergeMap(() => this.chatHubService.getProviders()
                .pipe(
                    map(chatHubProviders => setChatHubProvidersAction({ chatHubProviders })),
                    catchError(() => {
                        const chatHubProviders: NodeObject[] = [chatHubErrorObject]
                        return of(setChatHubProvidersAction({ chatHubProviders }))
                    })
                )
            )
        )
    )

    constructor(
        private actions$: Actions,
        private chatHubService: ChatHubService
    ) {
    }
}